import { useInstantSearch } from "react-instantsearch";

import renderChildren from "../../../../utils/renderChildren";

export default function InstantSearchIndexUiState({ children }) {
	const { indexUiState, setIndexUiState } = useInstantSearch();

	return renderChildren(children, { indexUiState, setIndexUiState });
}
